'use client';

import { motion } from 'framer-motion';
import { orbVisibility } from '../../../lib/orbBridge';
import { useMotionValueEvent } from 'framer-motion';
import { useState } from 'react';

/**
 * This component typically handles global UI elements related to the orb
 * or mounts the orb in a way that persists across the application.
 * In this implementation, it acts as a global atmosphere controller.
 */
export default function ScrollOrbOverlay() {
  const [visible, setVisible] = useState(true);

  useMotionValueEvent(orbVisibility, 'change', (latest) => {
    setVisible(latest > 0);
  });

  if (!visible) return null;

  return (
    <motion.div data-component-id="src/app/components/3d/ScrollOrbOverlay.tsx:23:4" data-component-path="src/app/components/3d/ScrollOrbOverlay.tsx" data-component-line="23" data-component-end-line="34" data-component-file="ScrollOrbOverlay.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%2C%22className%22%3A%22fixed%20inset-0%20pointer-events-none%20z-%5B100%5D%22%7D"
      className="fixed inset-0 pointer-events-none z-[100]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Global Cinematic Grain / Overlays can go here */}
      <div data-component-id="src/app/components/3d/ScrollOrbOverlay.tsx:30:6" data-component-path="src/app/components/3d/ScrollOrbOverlay.tsx" data-component-line="30" data-component-end-line="30" data-component-file="ScrollOrbOverlay.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-%5Burl('%2Fnoise.svg')%5D%20opacity-%5B0.03%5D%20mix-blend-overlay%22%7D" className="absolute inset-0 bg-[url('/noise.svg')] opacity-[0.03] mix-blend-overlay" />

      {/* Global Vignette */}
      <div data-component-id="src/app/components/3d/ScrollOrbOverlay.tsx:33:6" data-component-path="src/app/components/3d/ScrollOrbOverlay.tsx" data-component-line="33" data-component-end-line="33" data-component-file="ScrollOrbOverlay.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-radial-%5Bat_center%5D%20from-transparent%20via-transparent%20to-black%2F40%22%7D" className="absolute inset-0 bg-radial-[at_center] from-transparent via-transparent to-black/40" />
    </motion.div>
  );
}
